import { render } from "./MenuColorsCutsom.vue?vue&type=template&id=cbcbee98&scoped=true"
import script from "./MenuColorsCutsom.vue?vue&type=script&lang=js"
export * from "./MenuColorsCutsom.vue?vue&type=script&lang=js"

import "./MenuColorsCutsom.vue?vue&type=style&index=0&id=cbcbee98&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbcbee98"]])

export default __exports__